export default __webpack_public_path__ + "static/media/solid_background_3.95455cb0.png";